/**
 * Model interfaces for the Volumes and WIP page
 */

export interface VolumesAndWipProps {
  date?: string;
  shiftType?: string;
}

export interface VolumeTarget {
  recommended: number;
  override?: number;
  overrideReason?: string;
  overrideComment?: string;
}

export interface WipTarget {
  value: number;
  override?: number;
}

export interface CategoryVolume {
  name: string;
  volumeTarget: VolumeTarget;
  wipTarget?: WipTarget;
  expanded?: boolean;
}

export interface ShiftVolumeTarget {
  recommended: number;
  override: number;
}

export interface VolumesData {
  shiftVolumeTarget: ShiftVolumeTarget;
  categories: CategoryVolume[];
}

// Following are the new models for request/response for Volume api
// Will remove the above written older models later
export interface TargetAndWipVolume {
  displayName: string;
  label: string;
  targetVolume: number;
  wipVolume?: number;
}

export interface GetTargetAndWIPVolumeRequest {
  planId: string;
  date: string;
  warehouseId: string;
  shiftType: string;
}

export interface GetTargetAndWIPVolumeResponse {
  totalTargetVolume: number;
  primaryTargetAndWipVolume: TargetAndWipVolume[];
  secondaryTargetAndWipVolume: TargetAndWipVolume[];
}

export const buildGetTargetAndWIPVolumeRequest = (
    planId: string, date: string, warehouseId: string, shiftType: string
): GetTargetAndWIPVolumeRequest => {
  return {
    planId, date, warehouseId, shiftType
  }
}

// New override data structure interfaces
export interface VolumeDistribution {
  volume: number;
  operationName: string;
  overrideReason?: string;
  overrideComment?: string;
}

export interface SecondaryPathVolumeData {
  wipSecondaryVolumeDistribution: VolumeDistribution[];
  targetPrimaryVolumeDistribution: VolumeDistribution[];
  targetSecondaryVolumeDistribution: VolumeDistribution[];
}

export interface VolumeContext {
  secondaryPathVolumeData: SecondaryPathVolumeData;
}

export interface ProcessPathOverrides {
  volumeContext: VolumeContext;
}

export interface VerifyVolumeResponse {
  [key: string]: string | number | boolean | null | undefined;
}
